import { resolveAiCoverAspect } from './resolveAiCoverRequest';

// Fixed UTC−3 (no DST in São Paulo since 2019), matching the backend's
// `buildAiCoverMediaName` in src/lib/aiCover/coverMedia.js.
const SAO_PAULO_OFFSET_MS = 3 * 60 * 60 * 1000;

const pad = (n: number) => String(n).padStart(2, '0');

/** My Media name for a generated cover: `Capa IA – dd/mm HH:mm` in São Paulo
 *  time — the same name the backend listener registers it under. */
export function buildAiCoverMediaName(date: Date): string {
  const sp = new Date(date.getTime() - SAO_PAULO_OFFSET_MS);
  return `Capa IA – ${pad(sp.getUTCDate())}/${pad(sp.getUTCMonth() + 1)} `
    + `${pad(sp.getUTCHours())}:${pad(sp.getUTCMinutes())}`;
}

const AI_COVER_DIMENSIONS = {
  portrait: { width: 1024, height: 1536 },
  landscape: { width: 1536, height: 1024 },
} as const;

/** Pixel size of the image generated for an export aspect (width/height). */
export function aiCoverDimensions(exportAspect: number): { width: number; height: number } {
  return { ...AI_COVER_DIMENSIONS[resolveAiCoverAspect(exportAspect)] };
}
